/** @deprecated Use `getDepositAmountI18NKeyDetails` instead. */
const depositAmountStringBuilder = (defaultDepositAmountPercentage: number, depositType?: Tours.V2OfferDepositType, depositAmount?: number) => {
  const baseText = 'Secure with a'

  if (depositType === 'flat') {
    return { full: `${baseText} $${depositAmount}/person deposit`, short: `$${depositAmount}/person` }
  }

  if (depositType === 'percentage') {
    return { full: `${baseText} ${depositAmount}% deposit`, short: `${depositAmount}%` }
  }

  return { full: `${baseText} ${defaultDepositAmountPercentage}% deposit`, short: `${defaultDepositAmountPercentage}%` }
}

export default depositAmountStringBuilder

/**
 * i18n-friendly replacement for `depositAmountStringBuilder`.
 * The `type` property can be used as a context value for the i18n key `secureWithDepositLabel` from the `deposit` namespace.
 * The `options` property has additional options for the `t` function's `options` argument.
 *
 * Usage example:
 *
 * const depositAmountKeyDetails = getDepositAmountI18NKeyDetails(currentCurrency, defaultDepositAmountPercentage, depositType, depositAmountPercentage)
 *
 * t('secureWithDepositLabel', { ns: 'deposit', context: depositAmountKeyDetails.type, ...depositAmountKeyDetails.options })
 */
export const getDepositAmountI18NKeyDetails = (currencyCode: string, defaultDepositAmountPercentage: number, depositType?: Tours.V2OfferDepositType, depositAmount?: number): {
  /** Can be used as a context value for an i18n key */
  type: 'amountPerPerson' | 'percentage' | 'unspecified',
  /** Options to pass to `t` */
  options: Record<string, any>,
} => {
  if (depositType === 'flat') {
    return typeof depositAmount === 'number' ?
        { type: 'amountPerPerson', options: { amount: depositAmount, currency: currencyCode } } :
        { type: 'unspecified', options: {} }
  }

  if (depositType === 'percentage') {
    return typeof depositAmount === 'number' ?
        { type: 'percentage', options: { amount: depositAmount } } :
        { type: 'unspecified', options: {} }
  }

  return { type: 'percentage', options: { amount: defaultDepositAmountPercentage } }
}
